import React from "react";
import {
    Stack,
    ScrollablePane,
    ActivityItem,
    Theme,
    Icon,
    Text,
    useDateRender,
    getUsernameWithoutPrefix
} from "sprint-common-web";

import { NoteItem } from "./NoteItem";

export interface NotesListProps {
    notes: NoteItem[];
    height: number;
}

export const NotesList: React.FunctionComponent<NotesListProps> = (props: NotesListProps) => {
    const { renderDateTime } = useDateRender();

    return (
        <Stack style={{ height: props.height }}>
            <ScrollablePane>
                {props.notes.map((note: NoteItem, index: number) => (
                    <ActivityItem
                        key={index}
                        styles={{
                            root: { marginBottom: 10, width: "100%" },
                            activityContent: { width: "100%" }
                        }}
                        activityDescription={[
                            <Text
                                block={false}
                                nowrap={false}
                                key={1}
                                styles={{
                                    root: { fontWeight: "bold", color: Theme.palette.themeDarkAlt, paddingRight: 5 }
                                }}
                            >
                                {getUsernameWithoutPrefix(note.author)}
                            </Text>,
                            <Text block={false} nowrap={false} key={2}>
                                {"added note"}
                            </Text>
                        ]}
                        activityIcon={<Icon iconName="QuickNote" />}
                        comments={[
                            <Text key={1} nowrap={false}>
                                {note.content}
                            </Text>
                        ]}
                        timeStamp={renderDateTime(new Date(note.creationDate))}
                    />
                ))}
            </ScrollablePane>
        </Stack>
    );
};
